export default __webpack_public_path__ + "alberta-fab-copy.f5eb4e0863a6bb475fe7.svg";